export default __webpack_public_path__ + "search-examples-list-based-search-thumbnail-480-bd91ac8d934433109a6d4e6a2582ab4a.png";